import { useCallback, useEffect, useState } from "react"
import { useNavigate, useParams } from "react-router"
import useOrder from "../../../hooks/api/useOrder"
import { useSnackbar } from "notistack"
import { PATH_DASHBOARD } from "../../../routes/paths"
import useModal from "../../../hooks/useModal"

const useOrderPage = () => {

    const {idorder} = useParams()
    const { enqueueSnackbar } = useSnackbar();
    const orderManager = useOrder()
    const navigate = useNavigate()

    const [loading, setLoading] = useState()
    const [error, setError] = useState()
    const [order, setOrder] = useState()

    const modalManager = useModal({
        shipment_modal:false,
        update_shipment_modal:false,
        delete_user:false,
        add_product_order:false,
        assign_user_order:false,
        date_selector:false
    })

    const onGetOrder = useCallback(async() => {
        const response = await orderManager.actions.onGet(idorder)
        setOrder(response)
        return response
    }, [idorder])

    const onChange2PendingShipment = useCallback(async() => {
        setLoading(true)
        try {
            //enqueueSnackbar('Enviando...', {variant:"info"})
            await orderManager.actions.onSetPendingShipment(order?.id_order)
            await onGetOrder()
            enqueueSnackbar('Actualizado correctamente', {variant:"success"})
        } catch (error) {
            setError(error)
            enqueueSnackbar(error?.message, {variant:"error"})
        }
        setLoading(false)
    },[orderManager, onGetOrder, order])

    const onDeliver = useCallback(async() => {
        setLoading(true)
        try {
            //enqueueSnackbar('Enviando...', {variant:"info"})
            await orderManager.actions.onDeliver(order?.id_order)
            //setOrderType('delivered')
            //await sleep(500)
            //await actions.onRefreshSelectedOrder()
            await onGetOrder()
            enqueueSnackbar('Actualizado correctamente', {variant:"success"})
        } catch (error) {
            setError(error)
            enqueueSnackbar(error?.message, {variant:"error"})
        }
        setLoading(false)
    },[order])



    

    const initialize = useCallback(async() => {
        setLoading(true)
        try {
            await onGetOrder()
        } catch (error) {
            enqueueSnackbar(error?.message, {variant:'error'})
            navigate(PATH_DASHBOARD.order.list)
        }
        setLoading(false)
    }, [idorder])

    useEffect(() => {
        initialize()
    }, [idorder])

    return{
        loading,
        error,
        order,
        onGetOrder,
        modalManager,
        onChange2PendingShipment,
        onDeliver
    }

}

export default useOrderPage